export const COOKIE_NAMES = {
    IDENTIFIER: 'checkin_form_new.identifier',
    LASTNAME: 'checkin_form_new.lastname',
};

export const OPTIONS = { expires: 1 / 24 };

export const PATHS = {
    SEARCH: '/check-in-new',
    PASSENGERS: '/check-in-new/passengers',
    SEATS: '/check-in-new/services/seats',
    BAGGAGE: '/check-in-new/services/baggage',
    MEAL: '/check-in-new/services/meal',
    SERVICES: '/check-in-new/services',
    PAYMENT: '/check-in-new/payment',
    SUMMARY: '/check-in-new/summary',
    FAILURE: '/check-in-new/failure',
    TICKETS: '/tickets',
};

export const ERRORS = {
    UNKNOWN_ERROR: 'Неизвестная ошибка',
};

export const PAYMENT_MODE = {
    CRYPTOGRAM: 'cryptogram',
    TOKEN: 'token',
    SBP_QR: 'sbp_qr',
};

export const CARD_PAYMENT_STATUSES = {
    CREATED: 'created',
    HELD: 'held',
    CONFIRMED: 'confirmed',
    NOT_CREATED: 'not_created',
    CANCELLED: 'cancelled',
    EXPIRED: 'expired',
    DECLINED: 'declined',
};

export const UNSETTED_PAYMENT_ATTEMPT_VALUE = -1;
